import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

export const TeamPair = ({
  swapped,
  home,
  away,
  className,
}: {
  swapped: boolean;
  home: ReactNode;
  away: ReactNode;
  className?: string;
}) => (
  <div className={cn('flex w-full justify-between', className)}>
    {swapped ? away : home}
    {swapped ? home : away}
  </div>
);
